import _ from "lodash"
import * as R from "ramda"
import moment from "moment"
import storePersist from "../../redux/storePersist"
import { DecodedToken, decodeToken } from "./decode-jwt"

export const deepCopy = (obj: any) => JSON.parse(JSON.stringify(obj))
export const getCardData = (data: any, cardname: any) => {
    if (data.length) {
        const cardData: any = _.filter(data, ['CardName', cardname])[0].CardValue
        const cardVaules: any = JSON.parse(cardData)

        const values = JSON.parse(JSON.stringify(cardVaules));

        const transformedValues: any = [];
        let ictr = 0
        R.map(
            (valueSet: any) => {
                transformedValues.push([])
                R.map(
                    (value: any) => {
                        transformedValues[ictr].push({
                            [value.field]: value.value
                        })
                        return value
                    },
                    valueSet
                )
                transformedValues[ictr] = R.mergeAll(transformedValues[ictr])
                ictr += 1
                return valueSet
            },
            values
        )
        return transformedValues

    }

}


export const formatPageListData = (data: any) => {
    return _.map(data, (product: any) => {

        const item = {
            Id: product?.Message?.Id,
            PageName: product?.Message?.PageName,


        }
        return item
    });
}
export const formatWebsiteListData = (data: any) => {
    return _.map(data, (product: any) => {

        const item = {
            Id: product?.message?.Id,
            WebsiteName: product?.message?.WebsiteName,


        }
        return item
    });
}

export const formatLayoutListData = (data: any) => {
  return _.map(data, (product: any) => {
    const item = {
      Id: product?.Message?.Id,
      LayoutName: `${product?.Message?.LayoutName} : ${product?.Message?.PageName} : ${product?.Message?.PlatformWebSiteName}`,
    };
    return item
  });
};
export const transformCardValues = (cardValues: any) => {
    const values = deepCopy(cardValues)
    const transformedValues: any = [];
    let ictr = 0
    R.map(
      (valueSet) => {
        transformedValues.push([])
        R.map(
          (value) => {
            transformedValues[ictr].push({
              [value.field]: value.value
            })
            return value
          },
          valueSet
        )
        transformedValues[ictr] = R.mergeAll(transformedValues[ictr])
        ictr += 1
        return valueSet
      },
      values
    )
    return transformedValues
  }
  const keyMapped = (data: any) => {
    let type = ''
    if (data === 'src') {
      type = 'image'
    } else if (data === 'video') {
      type = 'video'
    } else if (data === 'email') {
      type = 'email'
    } else if (data === 'phone') {
      type = 'number'
    } else if (data === 'whatsapp') {
      type = 'number'
    }
    else if (data === 'product') {
      type = 'product'
    }
    else if (data === 'category') {
      type = 'category'
    } else {
      type = 'text'
    }
  
    return type
  }
  
  export const transformBackCardValues = (cardValues: any) => {
    const values = deepCopy(JSON.parse(cardValues))
    const transformedValues: any = [];
    let ictr = 0
    R.map(
      (valueSet) => {
        transformedValues.push([])
        R.mapObjIndexed(
          (value, key) => {
            transformedValues[ictr].push({
              field: key,
              type: keyMapped(key),
              value
            })
          },
          valueSet
        )
        ictr += 1
        return valueSet
      },
      values
    )
    return JSON.stringify(transformedValues)
  }

  
export const getFormattedDate = ({ date }: any) => (
    moment
        .utc(date)
        .format('YYYY-MM-DD hh:mm:ss a')
)

export const format = (date: any) => {
    if (date) {
        const localDateFormatted = moment(date).local()
            .format('YYYY-MM-DD hh:mm:ss a')
        return localDateFormatted
    }
    return ''
}

export const currency = (money: any) => {

  var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
  const countryCode  =
    metaTokenMetaData.CountryCode;
    const currencyCode = 
    metaTokenMetaData.CurrencyCode;
    const languageCode = 
    metaTokenMetaData.LanguageCode;

    const moneyArr: any = _.split(
        money,
        '.'
    )

    let finalMoneyString = Intl.NumberFormat(
        `${languageCode}-${countryCode}`,
        {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            maximumSignificantDigits: 3
        }
    ).format(moneyArr[0])

    if (moneyArr?.length > 1) {
        finalMoneyString += `.${moneyArr[1]}`
    }

    return finalMoneyString
}
export const getCurrencySymbol = (label: any) => {


    let currencySymbol: any = null;
    var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
    const countryCode  =
      metaTokenMetaData.CountryCode;
      const currencyCode = 
      metaTokenMetaData.CurrencyCode;
      const languageCode = 
      metaTokenMetaData.LanguageCode;

    if (label?.length > 0 &&
        R.find((subString) => label.indexOf(subString) > -1)([
            'Price',
            'Cost',
            'Amount',
            'Amt',
            'Charge',
            'Charges',
            'MRP'
        ])
    ) {
        // const options = { style: 'currency', currency: currencyCode };
        // const us = new Intl.NumberFormat(languageCode, options);
        const valueWithCurrency = Number(0).toLocaleString(languageCode, {
            style: "currency",
            currency: currencyCode,
            minimumFractionDigits: 2
        });
        const valueWithoutCurrency = valueWithCurrency.replace(Number(0).toLocaleString(languageCode, {
            minimumFractionDigits: 2
        }), "")

        currencySymbol = valueWithoutCurrency
    }
    return currencySymbol
}

export const getAccountTypeChannalName = () => {
    const token = storePersist?.get("accessToken")?.current?.JwtToken;

    if (token) {
        const decodedToken: DecodedToken | null = decodeToken(token);
        if (decodedToken) {

            return decodedToken;
        } else {
            // Handle invalid token
            // Redirect to login page, show error message, etc.
            return null;
        }
    } else {
        // Handle case when token is not present
        // Redirect to login page, show error message, etc.
        return null;
    }
}
export const getHostName = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'){
    return "fashme"
  } else {
    return window.location.hostname
  }    
}


export const getOrigin = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'){
    return "https://fashme.csp.digiit.io"
  } else {
    if (window.location.origin.includes('x.digiit.io')){
      return "https://dbs.csp.digiit.io"
    } else if(window.location.origin.includes('y.digiit.io')){
      return "https://agri.csp.digiit.io"
    } else if(window.location.origin.includes('z.digiit.io')){
      return "https://fashme.csp.digiit.io"
    } else if (window.location.origin.includes('x.digiit.ai')){
      return "https://dbs.csp.digiit.ai"
    } else if(window.location.origin.includes('y.digiit.ai')){
      return "https://agri.csp.digiit.ai"
    } else if(window.location.origin.includes('z.digiit.ai')){
      return "https://quco.csp.digiit.ai"
    } else if(window.location.origin.includes('fusionnet.digiit.io')){
      return "https://fashme.csp.digiit.io"
    } else if (window.location.origin.includes('edgenet.digiit.io')){
      return "https://fashme.csp.digiit.io"
    } else if(window.location.origin.includes('fusionnet.digiit.ai')){
      return "https://digiitbiz.csp.digiit.ai"
    } else if (window.location.origin.includes('edgenet.digiit.ai')){
      return "https://digiitbiz.csp.digiit.ai"
    } else
      return window.location.origin.replace(/\.digiit\./, ".csp.digiit.")
    }      
  }    